import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import { Typography, IconButton, Box, Tooltip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import InnerContent from '../../../components/PageStructure/InnerContent/InnerContent';
import PageContent from '../../../components/PageStructure/PageContent/PageContent';
import PageHeader from '../../../components/PageStructure/PageHeader/PageHeader';
import { paperStyle } from '../../../theme/AllocateBaseTheme';

const DefaultPageWrapper = props => {
  const { pageTitle, children, HeaderContent, showBackButton, goBack } = props;
  const BackButton = (
    <Tooltip>
      <IconButton className="back-btn" aria-label="back" size="small" color="primary" onClick={goBack}>
        <ArrowBackIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
  const HeaderContentInner = HeaderContent ? (
    <HeaderContent BackButton={BackButton} pageTitle={pageTitle} />
  ) : (
    <Box className="title-section" display="flex" px={2} py={1}>
      <Box>
        <Tooltip title={'Back'}>{showBackButton && BackButton}</Tooltip>
      </Box>
      <Box flexGrow={1}>
        <Typography className="admin-header-title" variant="h3">
          {pageTitle}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <PageContent pageTitle={pageTitle}>
      <div className="flex-page-content content-wrapper">
        {pageTitle !== null && <PageHeader>{HeaderContentInner}</PageHeader>}
        <InnerContent isBorderless>
          <div className="full-page">
            <Paper style={paperStyle}>{children}</Paper>
          </div>
        </InnerContent>
      </div>
    </PageContent>
  );
};

DefaultPageWrapper.defaultProps = {
  children: null,
  HeaderContent: null,
  showBackButton: true,
};

DefaultPageWrapper.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  children: PropTypes.node,
  showBackButton: PropTypes.bool,
  goBack: PropTypes.func.isRequired,
  // Will receive BackButton and pageTitle as props
  HeaderContent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export default DefaultPageWrapper;
